module.exports = __webpack_public_path__ + "static/media/loco-logo.7014cc9d.png";